import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  BankTransactionLiteModel,
  BankTransactionModel,
  getBankTransactionInput,
  getBankTransactionsInput,
} from './model';

export function useGetBankTransactions(
  input?: getBankTransactionsInput,
  options?: UseQueryOptions<
    ExtendedApiResult<BankTransactionLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<BankTransactionLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getBankTransactions', input?.params],
      () =>
        QueryFetchFunction({
          url: 'bank-transactions',
          params: input?.params,
        }),
      options,
    ),
    BankTransactionLiteModel,
  );
}

export function useGetBankTransaction(
  input?: getBankTransactionInput,
  options?: UseQueryOptions<ApiResult<BankTransactionModel>, ApiError>,
): UseQueryResult<ApiResult<BankTransactionModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getBankTransaction', input?.id],
      () =>
        QueryFetchFunction({
          url: `bank-transactions/${input?.id}`,
        }),
      options,
    ),
    BankTransactionModel,
  );
}

export function getBankTransactionsKey(input?: getBankTransactionsInput) {
  return ['getBankTransactions', input?.params];
}

export function getBankTransactionKey(input?: getBankTransactionInput) {
  return ['getBankTransaction', input?.id];
}
